import { render } from "./Sketch_chongqin.vue?vue&type=template&id=3275c3a3&scoped=true&ts=true"
import script from "./Sketch_chongqin.vue?vue&type=script&lang=ts"
export * from "./Sketch_chongqin.vue?vue&type=script&lang=ts"

import "./Sketch_chongqin.vue?vue&type=style&index=0&id=3275c3a3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3275c3a3"]])

export default __exports__